// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3VKgi","title":"styles_title__1aZ2M"};